<!-- eslint-disable max-len -->
<template>
  <router-link
    v-bind:to="`/organisations/${id}/overview`"
    class="bg-white rounded-md shadow-lg w-96 h-56 flex-none ml-5 transform motion-safe:hover:scale-110"
  >
    <div class="h-3/5 w-100 bg-blue-600 rounded-tr-md rounded-tl-md">
      <div class="flex justify-between w-5/6 m-auto h-full items-end">
        <p class="text-white font-bold text-2xl"> {{name}} </p>
        <svg
          v-if="type == 'org'"
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 m-0.5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="white"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"
          />
        </svg>
      </div>
    </div>
    <div class="w-5/6 m-auto">
        <p v-if="type == 'org'"><strong>Location:</strong> {{ location }} </p>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    id: String,
    name: String,
    type: String,
    location: String,
  },
};
</script>
